
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/visitor/market",
      function () {
        return require("private-next-pages/visitor/market/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/visitor/market"])
      });
    }
  